export const REASONING_VALUES = {
  'No selection': 0,
  'Based on evidence': 1,
  'Based on program rules': 2,
  Other: 3,
} as const
